<template>
	<div :class="{'pa-3': !withinPage}" v-if="item">
		<v-breadcrumbs v-if="!withinPage" :items="breadcrumbs" divider="&gt;"></v-breadcrumbs>

		<v-form ref="form" v-model="valid" lazy-validation class="pb-5">
			<v-text-field v-model="item.title" label="Title" :rules="rules.text" required></v-text-field>
			<v-text-field v-model="item.subtitle" label="Sub-title"></v-text-field>
			<autocomplete-brand :label="'Sponsored By'" :prepend-icon="null" v-model="item.brand"></autocomplete-brand>

			<v-flex class="images-wrapper mb-5 mt-3" xs12>
				<label>Normal Image</label>
				<label>Redeemed Image</label>
				<label>Heading Image</label>
				<image-upload 
				 	label="Image" 
					class="pa-0 image-wrapper" 
					:class="{'-no-image': !item.imageUrl}"
					:use-slot="true"
					v-model="item.imageUrl">
					<v-img v-if="item.imageUrl" class="img-preview elevation-1 mx-0" :src="item.imageUrl" :contain="true" width="200" height="200"></v-img>
					<v-img v-else class="img-preview elevation-1 mt-2" :src="`https://www.jeban.com/images/1px.png`" :contain="true" width="200" height="200"></v-img>
				</image-upload>
				<image-upload 
				 	label="Image" 
					class="pa-0 image-wrapper" 
					:class="{'-no-image': !item.expiredImageUrl}"
					:use-slot="true"
					v-model="item.expiredImageUrl">
					<v-img v-if="item.expiredImageUrl" class="img-preview elevation-1 mx-0" :src="item.expiredImageUrl" :contain="true" width="200" height="200"></v-img>
					<v-img v-else class="img-preview elevation-1 mt-2" :src="`https://www.jeban.com/images/1px.png`" :contain="true" width="200" height="200"></v-img>
				</image-upload>
				<image-upload 
				 	label="Image" 
					class="pa-0 image-wrapper" 
					:class="{'-no-image': !item.headingImageUrl}"
					:use-slot="true"
					v-model="item.headingImageUrl">
					<v-img v-if="item.headingImageUrl" class="img-preview elevation-1 mx-0" :src="item.headingImageUrl" :contain="true" width="200" height="200"></v-img>
					<v-img v-else class="img-preview elevation-1 mt-2" :src="`https://www.jeban.com/images/1px.png`" :contain="true" width="200" height="200"></v-img>
				</image-upload>
			</v-flex>

			<v-text-field v-model="item.smsMessage" label="SMS Message" :rules="rules.text" required></v-text-field>

			<label>Conditions</label>
			<content-text v-model="item.conditions"></content-text>

			<br class="mt-5">

			<v-text-field v-model="item.dialogTitle" label="Dialog Title" :rules="rules.text" required></v-text-field>
			<v-text-field v-model="item.dialogMessage" label="Dialog Message" :rules="rules.text" required></v-text-field>
			<v-text-field v-model="item.successTitle" label="Success Title"></v-text-field>
			<v-text-field v-model="item.successMessage" label="Success Message"></v-text-field>
			<v-text-field v-model="item.confirmButtonText" label="Confirm Button" :rules="rules.text" required></v-text-field>

			<v-layout xs12>
				<schedule-picker text-label="Expires" v-model="item.expiresAt"></schedule-picker>
			</v-layout>
		</v-form>

		<v-footer v-if="!withinPage" fixed flat height="auto" color="grey lighten-2 px-3">
			<v-layout row wrap>
				<v-btn color="primary" @click="handleSave" :disabled="!valid">Save</v-btn>
				<v-btn flat @click="handleCancel">Cancel</v-btn>
			</v-layout>
		</v-footer>
		<v-footer v-else flat height="auto">
			<v-layout row wrap>
				<v-btn color="primary" @click="handleSave" :disabled="!valid">Save</v-btn>
				<v-btn flat @click="$emit('close')">Cancel</v-btn>
			</v-layout>
		</v-footer>
	</div>
</template>

<script>
	import * as config from '@/config'
    import * as types from '@/stores/mutation-types'

	import AutocompleteBrand from '@/components/AutocompleteBrand.vue'
	import ContentText from '@/components/ContentText.vue'
	import ImageUpload from '@/components/ImageUpload.vue'
	import SchedulePicker from '@/components/SchedulePicker.vue'	

	export default {
		components: {
			'autocomplete-brand':   AutocompleteBrand,
			'content-text':  		ContentText,
			'image-upload': 		ImageUpload,
			'schedule-picker': 		SchedulePicker
		},
		props: {
			eventId: {
				type: Number,
				default: null
			},
			couponId: {
				type: Number,
				default: null
			},
			withinPage: {
				type: Boolean,
				default: false
			}
		},
		data () {
			return {
	        	apiUrl: `${config.BASE_URL}/coupon`,
				breadcrumbs: [
					{
						text: 'Home',
						disabled: false,
						href: `${config.PUBLIC_PATH}`
					},
					{
						text: 'Media Spaces',
						disabled: true,
						href: `${config.PUBLIC_PATH}media-spaces`
					},
					{
						text: 'Coupons',
						disabled: false,
						href: `${config.PUBLIC_PATH}treatment-spa/coupon`
					}					
				],
				valid: true,
				item: {
			        id: 0,
			        eventId: null,
			        title: '',
			        subtitle: '',
			        brandId: null,
			        brand: null,
			        sponsoredBy: null,
			        headingImageUrl: '',
			        imageUrl: '',
			        expiredImageUrl: '',
			        smsMessage: '',
					conditions: '',
					dialogTitle: '',
					dialogMessage: '',
					successTitle: '',
					successMessage: '',
					confirmButtonText: '',
					expiresAt: null
				},
				rules: {
					text: [
						v => !!v || 'Field is required'
					],					
					number: [
						v => !!v || 'Field is required',
						v => (parseInt(v) > 0) || 'Value must be greater than 0'
					],					
				}
			}
		},
		methods: {
			handleCancel ()
			{
				this.$router.push({'path': `${config.PUBLIC_PATH}treatment-spa/coupon`})
			},
		    handleSave () 
		    {
		    	if (this.$refs.form.validate()) {
		    		this.item.brandId = this.item.brand ? this.item.brand.id : null
		    		this.item.sponsoredBy = this.item.brand ? this.item.brand.title : ''
		    		this.item.eventId = this.eventId

			    	if (this.item.id) {
				    	axios.put(`${this.apiUrl}/${this.item.id}/data`, this.item)
				    		.then((response) => {
				    			if ((response.data.httpStatusCode == 200) || (response.data.httpStatusCode == 201)) {
				    				if (!this.withinPage) {
				    					this.$router.push({ path: `${config.PUBLIC_PATH}treatment-spa/coupon` })
				    				} else {
				    					this.$emit('saved')
				    				}
				    			} else {
				    				this.$store.commit(types.SET_ERROR_MSG, response.data.message)
				    			}
				    		}).catch(function (error) {

							})
			    	} else {
				    	axios.post(`${this.apiUrl}/data`, this.item)
				    		.then((response) => {
				    			if ((response.data.httpStatusCode == 200) || (response.data.httpStatusCode == 201)) {
				    				if (!this.withinPage) {
				    					this.$router.push({ path: `${config.PUBLIC_PATH}treatment-spa/coupon` })
				    				} else {
				    					this.$emit('saved')
				    				}
				    			} else {
				    				this.$store.commit(types.SET_ERROR_MSG, response.data.message)
				    			}
				    		}).catch(function (error) {

							})
			    	}
			    }
		    }
		},
		mounted () {
		    if ((this.$route.params.id !== undefined && !this.withinPage) || (this.withinPage && this.couponId)) {
		    	let couponId = (this.$route.params.id !== undefined && this.$route.params.id && !this.withinPage) ? parseInt(this.$route.params.id, 10) : parseInt(this.couponId, 10)

		    	axios.get(`${this.apiUrl}/${couponId}/data`)
		    		.then((response) => {
		    			this.item = response.data.data

						this.breadcrumbs.push({
							text: this.item.title,
							disabled: true,
							href: ''
						})
		    		})
		    }
		}
	}
</script>

<style lang="scss">
	.images-wrapper {
		display: grid;
		grid-template-columns: repeat(3, auto);
		grid-column-gap: 20px;
		grid-row-gap: 10px;
		justify-content: start;

		@media (max-width: 480px) {
			grid-template-columns: repeat(3, 1fr);

			.image-wrapper {
				> div {
					width: 100% !important;
					height: auto !important;
				}
			}
		}

		label  {
			text-align: center;
		}
	}
</style>